import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import './citizen-theme.css';
import { DarkModeProvider } from './hooks/useDarkMode';

/**
 * CitizenChrome — the citizen design boundary for the standalone public pages
 * (landing / signup).
 *
 * Applies the scoped `.citizen-root` (so the v2 brand CSS variables + --ion-*
 * bridge resolve only inside the citizen subtree, never leaking into Pro) and
 * the citizen dark-mode context, and wraps content in IonPage/IonContent so Ion
 * components render in their proper shadow-DOM context. Sits inside
 * IonicStandaloneView (App.tsx), which provides the fixed viewport box.
 */
export function CitizenChrome({ children }: { children: React.ReactNode }) {
  return (
    <DarkModeProvider>
      <div
        className="citizen-root"
        style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', background: 'var(--background)' }}
      >
        <div style={{ position: 'relative', width: '100%', maxWidth: '28rem', height: '100%' }}>
          <IonPage>
            <IonContent
              style={
                {
                  '--background': 'var(--background)',
                  '--padding-top': 'var(--ion-safe-area-top, env(safe-area-inset-top, 0px))',
                } as React.CSSProperties
              }
            >
              {children}
            </IonContent>
          </IonPage>
        </div>
      </div>
    </DarkModeProvider>
  );
}

export default CitizenChrome;
